import styled from 'styled-components'

export const UserInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;

  .info-item {
    display: flex;
    align-items: center;
    gap: 8px;

    strong {
      color: #333;
    }

    span {
      color: #666;
    }
  }

  .test-badge {
    background: #fff3cd;
    color: #856404;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #ffeaa7;
  }

  .live-badge {
    background: #d4edda;
    color: #155724;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #c3e6cb;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`

export const FiltersSection = styled.div`
  margin: 24px 0;
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;

  .filters-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (max-width: 968px) {
      flex-direction: column;
      align-items: stretch;
      gap: 16px;
    }
  }

  .search-section {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    input {
      width: 300px;
      margin-bottom: 0 !important;
    }

    button {
      height: 54px;
      padding: 0 20px;
      font-size: 14px;
      min-width: auto;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .filter-buttons {
    display: flex;
    flex-shrink: 0;

    button {
      height: 42px;
      padding: 0 16px;
      font-size: 14px;
      border: 1px solid #e0e0e0;
      background: #ffffff;
      color: #666;
      margin: 0;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
        border-left: none;
      }

      &:not(:first-child):not(:last-child) {
        border-radius: 0;
        border-left: none;
      }

      &:hover {
        background: #f5f5f5;
      }

      &[class*='primary'] {
        background: #000000;
        color: #ffffff;
        border-color: #000000;
        z-index: 1;
        position: relative;

        &:hover {
          background: #333333;
        }
      }
    }
  }
`

export const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;

  .MuiDataGrid-root {
    border: none;
  }

  .MuiDataGrid-cell:focus,
  .MuiDataGrid-cell:focus-within {
    outline: none;
  }

  .MuiDataGrid-row {
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
`

export const ActionsCell = styled.div`
  display: flex;
  gap: 4px;

  button {
    padding: 6px 12px;
    font-size: 12px;
    min-width: auto;
    white-space: nowrap;
  }
`

export const StatusBadge = styled.div<{ color: string }>`
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
`

export const TraceInfo = styled.div`
  margin-bottom: 20px;

  p {
    margin: 4px 0;
    font-size: 14px;
    color: #666;
  }

  .session-id {
    font-family: monospace;
    color: #888;
    font-size: 12px;
  }
`

export const TraceStats = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  .label {
    font-size: 12px;
    color: #888;
    margin-bottom: 4px;
  }

  .value {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;

  p {
    font-size: 16px;
    color: #666;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 80px 20px;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    color: #333;
  }

  p {
    font-size: 16px;
    color: #666;
  }
`

export const ErrorState = styled.div`
  text-align: center;
  padding: 80px 20px;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    color: #ff4444;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 24px;
  }
`
